import React from 'react';
import styled from 'styled-components';

import ThemeStyle, { FontSize } from '../../../lib/style/ThemeStyle';

export const Text = ({
  size = ThemeStyle.typography.size,
  weight = ThemeStyle.typography.weight,
  color = ThemeStyle.color,
  textAlign,
  lineHeight,
  children,
  ...props
}) => (
  <Span
    size={size}
    weight={weight}
    color={color}
    textAlign={textAlign}
    lineHeight={lineHeight}
    {...props}
  >
    {children}
  </Span>
);

Text.defaultProps = {
  size: 16,
  weight: 'regular',
  color: 'darkest',
};

const Span = styled.span`
  color: ${(props) => props.theme.color[props.color]};
  text-align: ${(props) => props.textAlign || 'start'};

  &,
  b {
    ${FontSize};
    font-weight: ${(props) => props.theme.typography.weight[props.weight]};
    line-height: ${(props) => props.lineHeight || 'normal'};
  }

  b {
    color: ${(props) => props.theme.color.orangePink};
  }
`;
